import { TreeNode } from 'primeng/api';
import { ITypedLookup } from '../../common/models/permission-marker-lookup';

export function flattenTreeNodes(
    nodes: TreeNode<ITypedLookup<string>>[],
    parent: TreeNode<ITypedLookup<string>> | undefined = undefined
): TreeNode<ITypedLookup<string>>[] {
    const flattenedNodes: TreeNode<ITypedLookup<string>>[] = [];

    nodes.forEach((node: TreeNode<ITypedLookup<string>>) => {
        const flattenedNode: TreeNode<ITypedLookup<string>> = { ...node, parent };

        flattenedNodes.push(flattenedNode);

        if (node.children && node.children.length > 0) {
            flattenedNodes.push(...flattenTreeNodes(node.children, flattenedNode)); // Pass the current node as parent
        }
    });

    return flattenedNodes;
}
